var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, } from 'react';
import { TextInput, } from '../TextInput/index';
import { dateFormats } from './constants';
// Currently we are only supporting two date formats: MMYYYY and MMDDYYYY. If we
// expand formats we will have to build more significant enum logic, but this
// sets up the props interface to be extensible to that.
const getFormat = (dateFormat) => (dateFormat === 'MMYYYY');
export const handleChangeWithMask = (value, onChange = () => { }, dateFormat, event) => {
    const MMYYYY = getFormat(dateFormat);
    const maxLength = MMYYYY ? 7 : 10;
    const replacer = (match, $1 = '', $2 = '', $3 = '') => (`${$1}/${$2.length === 2 && !MMYYYY ? `${$2}/` : $2}${$3}`);
    let { target: { value: newValue = '', }, } = event;
    const lastDigit = newValue.substring(newValue.length - 1);
    const regExp = new RegExp('^\\D$');
    if (regExp.test(newValue)) {
        newValue = '';
        return;
    }
    // Prevent entry of single digit between forward slashes
    // as well as successive forward slashes.
    if (newValue.match('/\\d/')
        || newValue.match('^\\d/')
        || newValue.match('//')) {
        return;
    }
    // User has deleted some digits and is editing.
    if (value
        && (newValue.length <= value.length)) {
        onChange(event);
        return;
    }
    // Max length reached, do nothing.
    if (newValue.length > maxLength) {
        return;
    }
    const matchArray1 = newValue.match('/[0-9]*?/');
    const matchArray2 = newValue.match('^.*?(?=/)');
    if (matchArray1
        && matchArray2
        && matchArray1[0].length !== 4
        && matchArray2[0].length !== 2) {
        onChange(event);
        return;
    }
    // Make sure Month is two digits.
    if (newValue.length === 1
        && !lastDigit.match('0|1')
        && !lastDigit.match('[^0-9]')) {
        newValue = `0${lastDigit}`;
    }
    // Make sure Day is two digits.
    if (!MMYYYY
        && newValue.length === 4
        && !lastDigit.match('[0-3]')
        && !lastDigit.match('[^0-9]')) {
        newValue = `${newValue.substring(0, 3)}0${lastDigit}`;
    }
    newValue = (newValue
        .replace(/[^0-9]/gi, '')
        .replace(/([0-9]{2})([0-9]{0,2})([0-9]{0,4})/g, replacer));
    event.target.value = newValue;
    onChange(event);
};
const defaultProps = {
    dateFormat: dateFormats.MMDDYYYY,
    error: '',
    value: '',
};
const DateInput = (_a) => {
    var { dateFormat = defaultProps.dateFormat, error = defaultProps.error, value = defaultProps.value } = _a, restProps = __rest(_a, ["dateFormat", "error", "value"]);
    const MMYYYY = getFormat(dateFormat);
    const basePlaceholder = MMYYYY ? 'MM/YYYY' : 'MM/DD/YYYY';
    const placeholder = () => (_jsxs("span", { children: [_jsx("span", Object.assign({ css: css `
          color: transparent;
        ` }, { children: value })), basePlaceholder.substring(value.length)] }));
    const changeHandler = useCallback((event) => {
        handleChangeWithMask(value, restProps.onChange, dateFormat, event);
    }, [
        dateFormat,
        restProps.onChange,
        value,
    ]);
    return (_jsx(TextInput, Object.assign({}, restProps, { error: error, mask: true, onChange: changeHandler, pattern: MMYYYY ? '(1[0-2]|0[1-9])/[0-9]{4}' : '(1[0-2]|0[1-9])/[0-3][0-9]/[0-9]{4}', placeholder: placeholder(), value: value })));
};
const MemoizedDateInput = memo(DateInput);
export { MemoizedDateInput as DateInput };
// MC-1068 Temporary hack for Storybook.
export default DateInput;
